export const DOCTOR_NAME = "Behandler";
export const CENTER_NAME = "Sted";
export const SPECIALIZATION_NAME = "Spesialitet";
export const SERVICE_NAME = "Tjeneste";
export const DATE_AND_TIME = "Dato og tid";
export const PRICE = "Pris";
export const CAMPAIGN_PRICE = "Kampanjepris";
